<template>
  <div id="footer" class="acea-row row-middle">
    <div
      @click="goPages2(index)"
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
    >
      <div v-if="item.icon1"
        class="iconfont"
        :class="item.icon1 + ' ' + (item.url === $route.path ? item.icon2 : '')"
      ></div>
	  <img v-if="!item.icon1 && item.url === $route.path"
	    class="imgssss"
	    :src="item.img2"
		style="width: 50px;height: 50px;"
	  ></img>
	  <img v-if="!item.icon1 && item.url !== $route.path"
	    class="imgssss"
	    :src="item.img1"
		style="width: 50px;height: 50px;"
	  ></img>
      <div>{{ item.name }}</div>
    </div>
  </div>
</template>
<script>
import { getUser } from "@api/user";
export default {
  name: "Footer",
  props: {},
  mounted: function() {
    this.User();
  },
  data: function() {
    return {
      userInfo: {},
      footerList: [
        {
          name: "首页",
          icon1: "icon-shouye-xianxing",
          icon2: "icon-shouye",
          url: "/"
        },
        {
          name: "分类",
          icon1: "icon-yingyongchengxu-xianxing",
          icon2: "icon-yingyongchengxu",
          url: "/category"
        },
        {
          name: "客服",
          // icon1: "icon-yingyongchengxu-xianxing",
		  img1:'http://app.funengtuan.com/messagexiao.png',
		  img2:'http://app.funengtuan.com/messagexiao.png',
          // icon2: "icon-yingyongchengxu",
          url: "/CustomerList123"
        },
        {
          name: "购物车",
          icon1: "icon-caigou-xianxing",
          icon2: "icon-caigou",
          url: "/cartall"
        },
        {
          name: "我的",
          icon1: "icon-yonghu-xianxing",
          icon2: "icon-yonghu",
          url: "/user"
        }
      ]
    };
  },
  methods: {
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
      });
    },
    goPages2(index) {
      let that = this;
      if (that.footerList[index].url == "/CustomerList123") {
        this.$router.push({
          path: "/CustomerList123",
          query: { mid: this.userInfo.merchant_id }
        });
      } else {
        this.$router.push({
          path: that.footerList[index].url
        });
      }
    }
  }
};
</script>
<style>
	.imgssss{
		padding: 3px;
		border-top: 1px solid #EBEBEB;
		margin-top: -27px;
		border-radius: 50%;
		background: #ffffff;
		z-index: 1;
	}
</style>
